// This file is auto-generated. Do not edit manually.
import { FieldName, mutations } from './updateList';

export const groupedUpdateList: Record<FieldName, mutations> = {
  absenceReasons: ['createAbsenceReasons', 'deleteAbsenceReasons'],
  absences: ['createAbsences', 'deleteAbsences'],
  assignments: ['createAssignments', 'deleteAssignments'],
  bigBlueButtons: ['createBigBlueButtons', 'deleteBigBlueButtons'],
  bildungsplattforms: ['createBildungsplattforms', 'deleteBildungsplattforms'],
  bulkUpdateOrCreateBpProfiles: ['bulkUpdateOrCreateBpProfiles'],
  calendarEvents: ['createCalendarEvents', 'deleteCalendarEvents'],
  calendarSubscriptions: ['createCalendarSubscriptions', 'deleteCalendarSubscriptions'],
  classes: ['createClasses', 'deleteClasses'],
  classGroups: ['createClassGroups', 'deleteClassGroups'],
  collaborations: ['createCollaboration', 'deleteCollaboration'],
  divisions: ['createDivisions', 'deleteDivisions'],
  eventJobs: ['createEventJobs', 'deleteEventJobs'],
  fileEntries: ['createFileEntries', 'deleteFileEntries'],
  foreignSyncMetas: ['createForeignSyncMetas', 'deleteForeignSyncMetas'],
  groups: ['addMembersToBpGroup', 'createBpGroup', 'deleteBpGroup', 'removeMembersFromBpGroup'],
  lessonJobs: ['createLessonJobs', 'deleteLessonJobs'],
  locations: ['createLocations', 'deleteLocations'],
  materials: ['createMaterials', 'deleteMaterials'],
  nextclouds: ['createNextclouds', 'deleteNextclouds'],
  notificationSettings: ['createNotificationSettings', 'deleteNotificationSettings'],
  organizations: ['createOrganizations', 'deleteOrganizations'],
  preferences: ['createPreferences', 'deletePreferences'],
  profiles: [
    'createBpProfile',
    'createProfiles',
    'deleteBpProfile',
    'deleteProfiles',
    'disconnectBpProfile',
    'mergeBpProfiles',
  ],
  recurrenceRules: ['createRecurrenceRules', 'deleteRecurrenceRules'],
  schoolYears: ['createBpSchoolYear', 'deleteBpSchoolYear'],
  subjects: ['createBpSubject', 'deleteBpSubject'],
  submissions: ['createSubmissions', 'deleteSubmissions'],
  teachingTopics: ['createTeachingTopics', 'deleteTeachingTopics'],
  teachingUnits: ['createTeachingUnits', 'deleteTeachingUnits'],
  threemaBroadcasts: ['createThreemaBroadcasts', 'deleteThreemaBroadcasts'],
  threemas: ['createThreemas', 'deleteThreemas'],
  virtualLocations: ['createVirtualLocations', 'deleteVirtualLocations'],
  workMaterials: ['createWorkMaterials', 'deleteWorkMaterials'],
  zooms: ['createZooms', 'deleteZooms'],
};
